import styled from 'styled-components';
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import CustomDropdown from '../dropdown/CustomDropDown';
import { Container, Row, Col, Collapse } from 'react-bootstrap';
import StyledText from '../styledComponents/StyledText';
import StyledLoading from '../loading/StyledLoading';
import NewDropDownIcon from '../svgIcons/NewDropDownIcon';
import * as _ from 'lodash';
import StyledButton from '../styledComponents/StyledButton';
import { openHelpSection } from '../../services/helpSectionSlice';
import { useDispatch } from 'react-redux';
import HelpIcon from '../svgIcons/HelpIcon';
import { preLiveCheckList } from '../../../utils/Constants';
import { useState } from 'react';

const renderExtraContent = (item) => {
  if (item?.domainRegistered && !item.nameserversUpdated) {
    return (
      <div className="d-flex justify-content-between align-items-center gap-2 ms-4">
        <StyledText
          as={'p'}
          color={'bodyMedium'}
          $fontSize={'16px'}
          $fontWeight={'400'}
          className="m-0"
        >
          Pending name servers update
          <br />
          Note: Please allow 24hrs to 48hrs for nameservers to propagate to the
          servers
        </StyledText>
      </div>
    );
  } else {
    return <></>;
  }
};

const ProfileDropDownStyle = styled.div`
  .menu-toggle {
    padding-block: 0;
  }

  .custom-drop-down .menu-dropdown {
    width: auto;
  }

  .CircularProgressbar .CircularProgressbar-path {
    stroke: ${({ theme }) => theme.primary} !important;
  }
  .CircularProgressbar .CircularProgressbar-text {
    fill: ${({ theme }) => theme.primary} !important;
  }
`;

const DropContainer = styled(Container)`
  width: 700px;
  background-color: #fff;
  max-height: calc(100vh - 80px);
  overflow: auto;
`;

const Sidebar = styled(Col)`
  background-color: ${({ theme }) => theme.primaryLight2};
`;

const StyledChecklist = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 18px;
  font-weight: 400;
  color: ${({ theme }) => theme.bodyMedium};

  li {
    padding: 0.5rem 0;
    align-items: center;

    border-bottom: 1px solid ${({ theme }) => theme.borderColor};

    .success {
      color: ${({ theme }) => theme.warning};
    }

    .warning {
      color: ${({ theme }) => theme.warning};
    }

    p {
      margin: 0;
    }

    .fa-check {
      color: ${({ theme }) => theme.success};
    }
  }
`;

const StyledChecklistHeading = styled.h3`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .heading{
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
  }

  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.headingColor};

  .success {
    color: ${({ theme }) => theme.warning};
  }

  .warning {
    color: ${({ theme }) => theme.warning};
  }

    p{
      margin: 0;
    }

    .fa-check{
      color: ${({ theme }) => theme.success};
    }
  }
`;

const CollapseButton = styled.button`
  background-color: transparent;
  border: none
  height: auto;
  width: auto;
  padding: 0;
`;

const StyledParentItem = styled.div`
  padding: 0 0.5rem;
`;

function Separator(props) {
  return (
    <div
      style={{
        position: 'absolute',
        height: '100%',
        transform: `rotate(${props.turns}turn)`,
      }}
    >
      <div style={props.style} />
    </div>
  );
}

function RadialSeparators(props) {
  const turns = 1 / props.count;
  return _.range(props.count).map((index) => (
    <Separator turns={index * turns} style={props.style} />
  ));
}

const renderStatusIcon = (status) =>
  status ? (
    <i className="fa fa-check success" />
  ) : (
    <i className="fa fa-clock-o warning" />
  );

const GettingStartedWizard = ({
  open,
  setOpen,
  tasks,
  completed,
  percentage,
  isFetching,
  preLiveChecks,
}) => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleOpenHelpSection = (title) => {
    setDropdownOpen(false);
    dispatch(
      openHelpSection({
        show: true,
        comingFrom: title,
      }),
    );
  };

  return (
    <ProfileDropDownStyle className="d-flex align-items-center">
      <CustomDropdown
        show={dropdownOpen}
        onToggle={() => setDropdownOpen((prev) => !prev)}
        dropDownProps={'border-0 ms-0'}
        toggleClassName={`border-0 bg-white d-flex align-items-center`}
        menuClassName={`mt-2 user-dropdown custom-position`}
        dropDownToggleProps={{
          as: 'div',
        }}
        dropdownToggle={
          <div style={{ width: 45, height: 45 }}>
            <CircularProgressbarWithChildren
              value={completed}
              text={`${percentage}%`}
              strokeWidth={10}
              styles={buildStyles({
                strokeLinecap: 'butt',
              })}
              maxValue={tasks}
            >
              <RadialSeparators
                count={tasks}
                style={{
                  background: '#fff',
                  width: '2px',
                  // This needs to be equal to props.strokeWidth
                  height: `${10}%`,
                }}
              />
            </CircularProgressbarWithChildren>
          </div>
        }
        align={'start'}
        dropdownMenu={
          <DropContainer className="rounded shadow">
            {isFetching ? (
              <StyledLoading />
            ) : (
              <Row className="h-100">
                <Sidebar
                  xs={12}
                  md={4}
                  className="d-flex flex-column justify-content-between align-items-center py-4"
                >
                  <div className="mb-4" style={{ width: 150, height: 150 }}>
                    <CircularProgressbarWithChildren
                      value={completed}
                      text={`${percentage}%`}
                      strokeWidth={10}
                      styles={buildStyles({
                        strokeLinecap: 'butt',
                        strokeColor: 'red',
                      })}
                      maxValue={tasks}
                    >
                      <RadialSeparators
                        count={tasks}
                        style={{
                          background: '#fff',
                          width: '2px',
                          // This needs to be equal to props.strokeWidth
                          height: `${10}%`,
                        }}
                      />
                    </CircularProgressbarWithChildren>
                  </div>
                  <div className="w-100 text-start">
                    <StyledText $fontSize="18px" $fontWeight="500">
                      Get Started!
                    </StyledText>
                    <StyledText
                      $fontSize="16px"
                      $fontWeight="400"
                      color="bodyMedium"
                    >
                      You are on your way to going live. Follow the steps below
                      to complete the onboarding.
                    </StyledText>
                  </div>
                </Sidebar>
                <Col
                  xs={12}
                  md={8}
                  className="d-flex flex-column py-4"
                  style={{ gap: '2rem' }}
                >
                  {preLiveCheckList.map((item, index) => (
                    <StyledParentItem key={item.title}>
                      <CollapseButton
                        onClick={() =>
                          setOpen((prev) => ({
                            ...prev,
                            [index]: prev[index] ? false : true,
                          }))
                        }
                        aria-controls={item.title}
                        aria-expanded={open[index]}
                        className="w-100"
                      >
                        {item.redirectUrl ? (
                          <StyledText
                            as={'a'}
                            color={'bodyMedium'}
                            $fontSize={'16px'}
                            $fontWeight={'400'}
                            href={item.redirectUrl}
                          >
                            <StyledChecklistHeading>
                              <div className="heading">
                                {renderStatusIcon(
                                  item.status(
                                    item.selector.map(
                                      (i) => preLiveChecks?.[i],
                                    ),
                                  ),
                                )}
                                <span
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <p className="text-start">{item.title}</p>
                                  {item?.helperText && (
                                    <p
                                      className="text-start"
                                      style={{ fontSize: 10 }}
                                    >
                                      {item.helperText}
                                    </p>
                                  )}
                                </span>
                              </div>
                              <i className="fa fa-external-link" />
                            </StyledChecklistHeading>
                          </StyledText>
                        ) : (
                          <StyledChecklistHeading>
                            <div className="heading">
                              {renderStatusIcon(
                                item.status(
                                  item.selector.map((i) => preLiveChecks?.[i]),
                                ),
                              )}
                              <span
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}
                              >
                                <p className="text-start">{item.title}</p>
                                {item?.helperText && (
                                  <p
                                    className="text-start"
                                    style={{ fontSize: 10 }}
                                  >
                                    {item.helperText}
                                  </p>
                                )}
                              </span>
                              {item.helpSectionTrigger && (
                                <StyledButton
                                  textButton
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenHelpSection(
                                      item.helpSectionTrigger,
                                    );
                                  }}
                                >
                                  <HelpIcon className="mb-1" fill="#000" />
                                </StyledButton>
                              )}
                            </div>
                            <span
                              style={{
                                transform: open[index]
                                  ? 'rotate(180deg)'
                                  : 'rotate(360deg)',
                                transition: 'transform 0.4s ease',
                              }}
                            >
                              <NewDropDownIcon size={20} />
                            </span>
                          </StyledChecklistHeading>
                        )}
                      </CollapseButton>

                      <Collapse in={open[index]}>
                        <div id={item.title}>
                          {item.subItems?.length && (
                            <StyledChecklist className="ms-4 p-1">
                              {item.subItems?.map((subItem) => (
                                <li key={subItem.title}>
                                  <div className="d-flex justify-content-between">
                                    {subItem.redirectUrl ? (
                                      <StyledText
                                        as={'a'}
                                        color={'bodyMedium'}
                                        $fontSize={'16px'}
                                        $fontWeight={'400'}
                                        href={subItem.redirectUrl}
                                      >
                                        <div className="d-flex align-items-center gap-2">
                                          <i className="fa fa-external-link" />
                                          <span
                                            style={{
                                              display: 'flex',
                                              flexDirection: 'column',
                                            }}
                                          >
                                            <p>{subItem.title}</p>
                                            {subItem?.helperText && (
                                              <p style={{ fontSize: 10 }}>
                                                {subItem.helperText}
                                              </p>
                                            )}
                                          </span>
                                        </div>
                                      </StyledText>
                                    ) : (
                                      <div className="d-flex align-items-center gap-2">
                                        <span
                                          style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                          }}
                                        >
                                          <p>{subItem.title}</p>
                                          {subItem?.helperText && (
                                            <p style={{ fontSize: 10 }}>
                                              {subItem.helperText}
                                            </p>
                                          )}
                                        </span>
                                      </div>
                                    )}
                                    {renderStatusIcon(
                                      subItem.status(
                                        preLiveChecks?.[subItem.selector],
                                      ),
                                    )}
                                  </div>
                                  {subItem.extraContent &&
                                    subItem.extraContent(
                                      preLiveChecks,
                                      renderExtraContent,
                                    )}
                                </li>
                              ))}
                            </StyledChecklist>
                          )}
                        </div>
                      </Collapse>
                    </StyledParentItem>
                  ))}
                </Col>
              </Row>
            )}
          </DropContainer>
        }
      />
    </ProfileDropDownStyle>
  );
};

export default GettingStartedWizard;
